import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
    apiKey: "AIzaSyAGS5fUPu8F2vnpoZDLpRxbiKQ295yu_Ls",
    authDomain: "marvel-8b94b.firebaseapp.com",
    projectId: "marvel-8b94b",
    storageBucket: "marvel-8b94b.firebasestorage.app",
    messagingSenderId: "36541059490",
    appId: "1:36541059490:web:2948ab7ee1ead58690a2fb",
    measurementId: "G-164RB3Z0V2"
  };
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

export { db };